<template>
    <section class="d-flex flex-fill">
        <div class="d-flex flex-fill" ref="stageCanvas">
            <canvas
                ref="canvas"
                class="flex-fill",
                width="0"
                height="0"
            >
            </canvas>
        </div>
        <ToolbarComp />
    </section>
</template>

<script>
import { Creator } from '@/lib/visionary/visionary';
import ToolbarComp from './appearence/ToolbarComp.vue';

export default {
    name: 'CenterComp',
    props: {
        creator: {
            type: Creator,
            required: false
        }
    },
    components: {
        ToolbarComp
    },
    data() {
        return {
            selected: {
                x: 120,
                y: 100,
                width: 800,
                height: 520,
                radius: 12,
                fill: '#ffffff',
                stroke: '#4f5d75',
                strokeWidth: 2,
                opacity: 100
            }
        }
    },
    computed: {},
    beforeMount() {},
    mounted() {},
    beforeUnmount() {},
    methods: {}
}
</script>

<style scoped>
</style>
